<template>
  <div class="proof">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5">
        <img src="../../assets/img/titleLine.png" alt="" /> 打印凭证
      </h5>
      <div
        class="back  display-flex  align-items-center"
        @click="$router.back()"
      >
        返回列表 <img src="../../assets/img/backIconRight.png" alt="" />
      </div>
    </div>
    <!-- ../../assets/images/proof.jpg -->
    <div id="imgId">
      <div style="text-align:center">
        <img
          style="width:700px;height:490px"
          class="proofImg"
          id="proofImg"
          src="../../assets/img/hgzs.png"
          alt=""
        />
      </div>
    </div>
    <div class="btn">
      <button type="button" class="print" @click="handlePrint()">
        打印凭证
      </button>
      <button type="button" class="save" @click="handleDownload">
        保存本地
      </button>
    </div>
  </div>
</template>

<script>
import { postDataJxjy, showLoading, base } from "../../assets/api/api.js";
import axios from "axios";
export default {
  name: "proof",
  components: {},
  data() {
    return {
      imgUrl: "",
    };
  },
  created() {
	// this.imgUrl = this.$route.query.img;
	this.imgUrl = "../../assets/img/hgzs.png";
	
  },
  mounted() {},
  computed: {},
  methods: {
  //   loadData() {
		// console.log(111)
  //     var params = { id: this.$route.query.id };
  //     postDataJxjy("/member/tenpoint/getQualifyDetail", params).then(res => {
		// console.log(res);
  //     	this.imgUrl = res.data;
  //     	// console.log(res, 99999);
  //     }).catch(function(error) {
  //     	// console.log('error：' + error);
  //     });
  //   },
    handleDownload() {
      //   postData("student/proxyUrlFile", {
      //     responseType: "blob",
      //     url: this.imgUrl,
      //   }).then((res) => {
      //     var mime = "image/jpeg";
      //     var fileName = "凭证";
      //     let blob = new Blob([res.data], { type: mime });
      //     // 注: mime类型必须整正确, 否则下载的文件会损坏
      //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //       // 兼容IE
      //       window.navigator.msSaveOrOpenBlob(blob, element.original_name);
      //     } else {
      //       let downloadElement = document.createElement("a");
      //       downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
      //       downloadElement.download = fileName;
      //       downloadElement.click();
      //       window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
      //     }
      //   });
      // var url = base + "student/proxyUrlFile?url=" + this.imgUrl;
      var url = "../../assets/img/hgzs.png";
      this.downloadIamge(url, "凭证", "image/jpeg");
    },
    downloadIamge(url, fileName, mime) {
      // 下载附件
      url = axios
        .get(url, { responseType: "blob" })
        .then((res) => {
          let blob = new Blob([res.data], { type: mime });
          // 注: mime类型必须整正确, 否则下载的文件会损坏
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // 兼容IE
            window.navigator.msSaveOrOpenBlob(blob, element.original_name);
          } else {
            let downloadElement = document.createElement("a");
            downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
            downloadElement.download = fileName;
            downloadElement.click();
            window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
	
    handlePrint() {
      var printDom = document.getElementById("imgId").innerHTML;
      var printWindow = window.open();
      printWindow.document.write(printDom);
      printWindow.print();
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.proof {
  margin-bottom: 25px;
  width: 962px;
  background: #fff;
  float: right;
  text-align: center;
  .back {
    margin-right: 20px;
    cursor: pointer;
    color: #999999;
    font-size: 14px;
  }
  .btn {
    text-align: center;
    margin-bottom: 30px;
    button {
      line-height: 40px;
      border: 1px solid rgba(22, 26, 33, 1);
      width: 180px;
      border-radius: 4px;
    }
    .save {
      background: #fff;
      margin-left: 20px;
    }
    .print {
      color: #fff;
      background: rgba(22, 26, 33, 1);
    }
  }
  .proofImg {
    margin-top: 20px;
    margin-bottom: 45px;
    display: inline-block;
    width: 770px;
    height: 544px;
  }
  .publicTitle {
    margin-bottom: 0px !important;
  }
}
</style>
